import styled from 'styled-components';
import { rem } from 'polished';

export const DotDelimeter: any = styled.div`
  margin: 0 ${rem(8)};
  height: ${rem(2)};
  width: ${rem(2)};
  background-color: ${({ theme }) => theme.colors.placeholder};
  border-radius: 50%;
  display: inline-block;
`;
